export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '任务名称',
    dataIndex: 'task_name',
  },
  {
    title: '反馈用户',
    dataIndex: 'user_realname',
  },
  {
    title: '反馈内容',
    dataIndex: 'content',
  },
  {
    title: '反馈时间',
    dataIndex: 'create_time',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
